"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_dom_1 = __importDefault(require("react-dom"));
const app_1 = __importDefault(require("./app"));
const core_1 = require("@ag-grid-enterprise/core");
const js_1 = __importDefault(require("@bugsnag/js"));
const plugin_react_1 = __importDefault(require("@bugsnag/plugin-react"));
core_1.LicenseManager.setLicenseKey("CompanyName=DevelTip s.r.o.,LicensedApplication=ZAS,LicenseType=SingleApplication,LicensedConcurrentDeveloperCount=1,LicensedProductionInstancesCount=1,AssetReference=AG-013479,ExpiryDate=6_February_2022_[v2]_MTY0NDEwNTYwMDAwMA==10c315b3009e1e153c6149d9c1821ca3");
let ErrorBoundary = (props) => (props.children);
// @ts-ignore
if (window.BUGSNAG_KEY) {
    js_1.default.start({
        // @ts-ignore
        apiKey: window.BUGSNAG_KEY,
        plugins: [new plugin_react_1.default()]
    });
    // @ts-ignore
    ErrorBoundary = js_1.default.getPlugin('react')
        .createErrorBoundary(react_1.default);
}
const production = process.env.NODE_ENV;
react_dom_1.default.render((production ? (react_1.default.createElement(ErrorBoundary, null,
    react_1.default.createElement(react_1.default.StrictMode, null,
        react_1.default.createElement(app_1.default, null)))) : (react_1.default.createElement(react_1.default.StrictMode, null,
    react_1.default.createElement(app_1.default, null)))), document.getElementById('root'));
